module.exports = __webpack_public_path__ + "static/img/double_ring.5d02e09.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/eventicon/double_ring.gif
// module id = 4w63
// module chunks = 1